import React from 'react';
import store, { persistor } from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { SidebarProvider } from './contexts/SidebarContext';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import AuthWrapper from './components/AuthWrapper';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const NotFound = () => <p>sdsa</p>;
function Root() {
  return (
    <ClerkProvider
      publishableKey={clerkPubKey}
      navigate={(to) => (window.location.href = to)}>
      <Provider store={store}>
        <PersistGate loading={<NotFound />} persistor={persistor}>
          <Router>
            <SidebarProvider>
              <AuthWrapper>
                <App />
              </AuthWrapper>
            </SidebarProvider>
          </Router>
        </PersistGate>
      </Provider>
    </ClerkProvider>
  );
}

export default Root;
